var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarAlt = function SvgCalendarAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.533 5.108H5.849a2.893 2.893 0 0 0-2.893 2.894v8.903a2.893 2.893 0 0 0 2.893 2.893h10.684a2.893 2.893 0 0 0 2.893-2.893V8.002a2.893 2.893 0 0 0-2.893-2.894Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.518 3.328v3.116M3.847 9.115h14.69M16.31 3.328v3.116",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.852 13.344a.668.668 0 1 0 0-1.335.668.668 0 0 0 0 1.335ZM11.414 13.344a.668.668 0 1 0 0-1.335.668.668 0 0 0 0 1.335ZM14.974 13.344a.668.668 0 1 0 0-1.335.668.668 0 0 0 0 1.335ZM7.852 16.905a.668.668 0 1 0 0-1.336.668.668 0 0 0 0 1.336ZM11.414 16.905a.668.668 0 1 0 0-1.336.668.668 0 0 0 0 1.336ZM14.974 16.905a.668.668 0 1 0 0-1.336.668.668 0 0 0 0 1.336Z",
    fill: "#1E5DFF"
  })));
};
export default SvgCalendarAlt;